<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1574_240)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M13.4173 1.41732C13.4173 0.634557 12.7828 0 12 0C11.2172 0 10.5827 0.634557 10.5827 1.41732V10.5827H1.41732C0.634557 10.5827 0 11.2172 0 12C0 12.7828 0.634557 13.4173 1.41732 13.4173H10.5827V22.5827C10.5827 23.3654 11.2172 24 12 24C12.7828 24 13.4173 23.3654 13.4173 22.5827V13.4173H22.5827C23.3654 13.4173 24 12.7828 24 12C24 11.2172 23.3654 10.5827 22.5827 10.5827H13.4173V1.41732Z" fill="#5B6770"/>
</g>
<defs>
<clipPath id="clip0_1574_240">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
